<form class="form-vertical" id="edittrackervalueform" data-hook="edittrackervalueform">
    <div class="row">
        <div class="form-group col-xs-12 col-md-6">
            <label for="date">Datum
                <sprhelp tip="Eingabeformat" descref="vm.datehelp"></sprhelp>
                <span ng-show="vm.dateerror" style="color: #cc3333"><i
                    class="fa fa-warning"></i> {{vm.dateerror}}</span></label>


            <input ng-show="!vm.trackervalue.dateat  || vm.trackervalue.dateat === 'Invalid date'"
                   type="text" ng-model="vm.trackervalue.date" tabindex="0"
                   ng-blur="vm.formatdate(vm.trackervalue.date)"
                   class="form-control" id="date"
                   ng-focus="vm.setCurrentField('date')"
                   ng-change="vm.setCurrentFieldContent(vm.trackervalue.date)"
                   placeholder="TTMMJJJJ">

            <div class="input-group" ng-show="vm.trackervalue.dateat  && vm.trackervalue.dateat !== 'Invalid date'">
                <input type="text" class="form-control"
                       id="dateat"
                       readonly
                       ng-model="vm.trackervalue.dateat">
                <span class="input-group-btn">
        <button class="btn btn-danger"
                ng-click="vm.cleardate()"><i class="fa fa-remove"></i>
        </button>
      </span>
            </div>
        </div>
        <div class="form-group col-xs-12 col-md-6">
            <label>{{tracker.name}}</label>
            <div class="row" ng-repeat="def in vm.trackervalue.def">
                <div class="col-xs-8 col-md-6 text-right">{{def.label}}</div>
                <div class="col-xs-4 col-md-6">
                    <input type="number" step="def.step" min="def.absmin" max="def.absmax"
                           ng-model="def.value" class="form-control">
                </div>
            </div>

        </div>
    </div>

    <div class=" row">
        <div class="col-xs-12">
            <div class="form-group">
                <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>
                <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>
            </div>
        </div>
    </div>
</form>